import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import SafeLink from "modules/components/SafeLink";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { capitalize } from "util/lodash/capitalize";
import styles from "./manufacturer.module.scss";

function Manufacturer({ manufacturerImageLogoUrl, manufacturer, url }) {
  return (
    <SafeLink href={url}>
      <PAImage
        src={getRelativeImagePath(manufacturerImageLogoUrl)}
        alt={manufacturer}
        width={300}
        height={100}
      />
      <PAText
        component="h3"
        fontSize={FONT_SIZE[3]}
        className={styles.manufacturer_item}
        color="light-black"
      >
        {capitalize(manufacturer)}
      </PAText>
    </SafeLink>

  );
}

export default Manufacturer;
